<template>
    <div class="w_inner">
          <div class="con_box inner_banner join wow fadeIn animated" data-wow-delay="0.0s">
              <div class="text_conShow w">
                  <div class="text_box">
                    <div class="title wow fadeInUp animated"  data-wow-delay="0.2s"></div>
                    <div class="con wow fadeInUp animated" data-wow-delay="0.4s" v-html="utils.ShowContentBr(CompanyInfo.joinContent)">
                    </div>
                  </div>
              </div>
         </div>
         <div class="innerWrap">
            <div class="breadmapShow">
                <div class="bread-wrapper w">
                    <span>{{$t('join.title')}}</span>
                    <span>{{$t('join.detail')}}</span>
                </div>
            </div>
            <div class="main_container w">
                 <div class="joinDetailShow wow fadeIn animated" data-wow-delay="0.2s">
                     <div class="postname">{{dto.title}}</div>
                     <div class="subTitle">{{dto.subTitle}}</div>
                     <div class="contentShow">
                           <div class="conTi">{{$t('join.description')}}</div>
                           <div class="textCon" v-html="utils.ShowContentBr(dto.content)">
                           </div>
                     </div>
                      <div class="return_list"><router-link :to="{ name: 'join' }" ><span>{{$t('join.back')}}</span></router-link></div>
                 </div>
                
            </div>
             
         </div>
    </div>
</template>
  
<script>
import {mapState} from 'vuex'
import WOW from "../../node_modules/wowjs/dist/wow";
  export default {
    data() {
      return {
        dto:{},
        id:this.$route.params.id,
      }
    },
    computed:{
        ...mapState({
        CompanyInfo:state=>state.CompanyInfo
        })
    },
    components: {
       
    },
    mounted() {
        //滚动页面加载动画
        let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
        });
        wow.init();
    },
    created() {
        this.GetDetail();
    },
    methods:{
        GetDetail() {
            var url = "/pageapi/Job/GetDetail";
            this.$http.post(url,{id:this.id}).then(function(res){
                if (res.data.status==1){
                   this.dto = res.data.ds;
                }
            }.bind(this)).catch(function(){
            });
        },
    },

  }
</script>
